import { type BillingCustomer } from '../../models/Plan'

export const inFreeTrial = (customer?: BillingCustomer) => !!customer?.freeTrial?.startedAt && !customer.freeTrial.endedAt

export const hidesBillingInfo = (customer?: BillingCustomer) => !!customer?.enterpriseSubscription?.enterpriseBillingConfig.package.hideBillingInfo

export const isAggregateBilling = (customer?: BillingCustomer) => customer?.enterpriseSubscription?.enterpriseBillingConfig.package.type === 'aggregate'

export const isEmailInvoiced = (customer?: BillingCustomer) => customer?.subscription?.paymentType === 'emailInvoice'
